export const INVALID_PROFILE_EXCEPTION = 'Invalid Profile'
export const INVALID_PROFILE_URL_KEY = 'invalidProfile'
